import { Link } from "react-router-dom";

export default function Ethics() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16 md:py-24 text-foreground">
      <header className="mb-12 border-b border-border pb-8">
        <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-3">
          Ethics Guidelines
        </h1>
        <p className="text-base text-muted-foreground">
          Last updated May 4, 2026
        </p>
      </header>

      <section className="mb-16">
        <h2 className="text-2xl md:text-3xl font-semibold tracking-tight mb-6">
          Why Ethics Matter
        </h2>
        <div className="space-y-5 text-lg leading-relaxed">
          <p>Memory deserves more than technology. It deserves consent.</p>
          <p>
            As digital and AI tools make it possible to recreate voices,
            images, and stories, the line between remembrance and misuse
            becomes thin. Without clear boundaries, families are left with
            uncertainty — and individuals lose control over how they are
            remembered.
          </p>
          <p>
            LegacyLens was built on a simple principle: people should decide,
            in life, how they are remembered.
          </p>
          <p>
            That's why we require explicit consent, place clear limits on how
            digital representations can be used, and work to clearly disclose
            when AI is generating responses or voice. We believe ethical
            restraint isn't a limitation — it's what makes remembrance
            meaningful, trusted, and lasting.
          </p>
          <p>Ethics matter because memory is human, not synthetic.</p>
        </div>
      </section>

      <div className="mt-16 pt-8 border-t border-border">
        <p className="text-base text-muted-foreground">
          Read our full ethics framework in the{" "}
          <Link
            to="/digital-legacy-directive"
            className="font-medium underline-offset-4 hover:underline text-foreground"
          >
            Digital Legacy Directive
          </Link>
          {" "}→
        </p>
      </div>
    </main>
  );
}
